var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { onFileUpload } from "./checkListAPI";
export const requiredProps = [
    "memberId",
    "memberName",
    "providerName",
    "providerAddress",
    "providerPhone",
    "providerNpiNum",
    "providerTaxId",
    "cptDiagnosisCode",
    "providerSuperbill",
    "paymentProof",
    "chargedAmount",
    "paidAmount",
    "serviceDate,",
];
export const submitData = ({ selectedMember, status, reimbursementFlow, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    if (!(reimbursementFlow === null || reimbursementFlow === void 0 ? void 0 : reimbursementFlow.id)) {
        const GetIdForImgOBJ = {
            status: "PENDING",
            memberId: selectedMember.memberId,
            memberName: selectedMember.memberName,
        };
        try {
            const noMemberIdResponse = yield axios.post("https://dev.fabric.carynhealth.com/api/v17/memberportal/reimbursement", GetIdForImgOBJ);
            reimbursementFlow.id = noMemberIdResponse.data.response.id;
        }
        catch (error) { }
    }
    const requiredData = {
        memberId: selectedMember.empId,
        memberName: selectedMember.memberName,
        providerName: (reimbursementFlow === null || reimbursementFlow === void 0 ? void 0 : reimbursementFlow.providerName) || "",
        providerAddress: (reimbursementFlow === null || reimbursementFlow === void 0 ? void 0 : reimbursementFlow.providerAddress) || "",
        providerPhone: (reimbursementFlow === null || reimbursementFlow === void 0 ? void 0 : reimbursementFlow.providerPhone) || "",
        providerNpiNum: (reimbursementFlow === null || reimbursementFlow === void 0 ? void 0 : reimbursementFlow.providerNpiNum) || "",
        providerTaxId: (reimbursementFlow === null || reimbursementFlow === void 0 ? void 0 : reimbursementFlow.providerTaxId) || "",
        cptDiagnosisCode: (reimbursementFlow === null || reimbursementFlow === void 0 ? void 0 : reimbursementFlow.cptDiagnosisCode) || "",
        chargedAmount: (reimbursementFlow === null || reimbursementFlow === void 0 ? void 0 : reimbursementFlow.chargedAmount) || "",
        paidAmount: (reimbursementFlow === null || reimbursementFlow === void 0 ? void 0 : reimbursementFlow.paidAmount) || "",
        primaryEmail: localStorage.getItem("userMail"),
        serviceDate: (reimbursementFlow === null || reimbursementFlow === void 0 ? void 0 : reimbursementFlow.serviceDate) || "",
        id: (reimbursementFlow === null || reimbursementFlow === void 0 ? void 0 : reimbursementFlow.id) || "",
        status,
    };
    if (selectedMember.memberId) {
        console.log("1: First");
        if (((_a = reimbursementFlow.providerSuperbill) === null || _a === void 0 ? void 0 : _a.blobFile) ||
            ((_b = reimbursementFlow.paymentProof) === null || _b === void 0 ? void 0 : _b.blobFile)) {
            if ((_c = reimbursementFlow.providerSuperbill) === null || _c === void 0 ? void 0 : _c.blobFile) {
                try {
                    const providerBillImgPath = yield onFileUpload(reimbursementFlow.providerSuperbill, Object.assign(Object.assign(Object.assign({}, reimbursementFlow), selectedMember), requiredData));
                    requiredData.providerSuperbill = providerBillImgPath;
                }
                catch (error) { }
            }
            if ((_d = reimbursementFlow.paymentProof) === null || _d === void 0 ? void 0 : _d.blobFile) {
                try {
                    const paymentProofImgPath = yield onFileUpload(reimbursementFlow.paymentProof, Object.assign(Object.assign(Object.assign({}, reimbursementFlow), selectedMember), requiredData), "paymentProof");
                    requiredData.paymentProof = paymentProofImgPath;
                }
                catch (error) {
                    console.log("Error paymentProof: ", error);
                }
            }
        }
        else {
            requiredData.providerSuperbill = reimbursementFlow.providerSuperbill;
            requiredData.paymentProof = reimbursementFlow.paymentProof;
        }
    }
    if (!selectedMember.memberId &&
        reimbursementFlow.providerSuperbill &&
        reimbursementFlow.paymentProof) {
        const GetIdForImgOBJ = {
            status: "PENDING",
            memberId: selectedMember.memberId,
            memberName: selectedMember.memberName,
        };
        try {
            const noMemberIdResponse = yield axios.post("https://dev.fabric.carynhealth.com/api/v17/memberportal/reimbursement", GetIdForImgOBJ);
            const providerBillImgPath = yield onFileUpload(reimbursementFlow.providerSuperbill, Object.assign(Object.assign({}, reimbursementFlow), selectedMember), "", noMemberIdResponse);
            const paymentProofImgPath = yield onFileUpload(reimbursementFlow.paymentProof, Object.assign(Object.assign({}, reimbursementFlow), selectedMember), "", noMemberIdResponse);
            requiredData.providerSuperbill = providerBillImgPath;
            requiredData.paymentProof = paymentProofImgPath;
        }
        catch (error) { }
    }
    requiredData.providerSuperbill || (requiredData.providerSuperbill = reimbursementFlow.providerSuperbill);
    requiredData.paymentProof || (requiredData.paymentProof = reimbursementFlow.paymentProof);
    const URL = "https://dev.fabric.carynhealth.com/api/v17/" +
        "memberportal/reimbursement";
    return axios.post(URL, requiredData);
});
